import { get } from "lodash";

export class HealthDeclarationForm {
  public height: number | undefined;
  public weight: number | undefined;
  public illessSelection: string[] | undefined;
  public q1: string | undefined;
  public q2: string | undefined;
  public q3: string | undefined;
  public q4: string | undefined;
  public q5: string | undefined;
  public httSelection: string | undefined;
  public q6: string | undefined;
  constructor(initial: any){
    this.height = get(initial, 'height', undefined);
    this.weight = get(initial, 'weight', undefined);
    this.illessSelection = get(initial, 'illessSelection', []);
    this.q1 = get(initial, 'q1', undefined);
    this.q2 = get(initial, 'q2', undefined);
    this.q3 = get(initial, 'q3', undefined);
    this.q4 = get(initial, 'q4', undefined);
    this.q5 = get(initial, 'q5', undefined);
    this.httSelection = get(initial, 'httSelection', undefined);
    this.q6 = get(initial, 'q6', undefined);
  }
  get reviewHealth(): { text: string, children?: any[], value: any }[] {
    const list: any = [
      
      {
        text: 'Do you suffer from, or have you been treated for the following conditions?',
        children: [
          'Cancer, diabetes, stroke, AIDS or HIV infection',
          'Heart disease (cardiomyopathy, coronary artery disease, heart attack, ischaemic heart disease)',
          'Kidney disease (chronic kidney disease, kidney failure, kidney or ureter tumour)',
          'Liver disease (cirrhosis, hepatitis C, autoimmune hepatitis, liver failure, alcoholic liver disease, liver cancer, hepatoma)',
          'Lung disease (lung tumour, sarcoidosis, bronchiectasis or pneumoconiosis, chronic obstructive pulmonary disease)',
          "Dementia, Alzheimer's disease, Parkinson's disease, multiple sclerosis, motor neurone disease"
        ],
        value: this.getValue(this.q1),
        id: 1
      },
      {
        text: 'Do you suffer from, or have you been treated for the following conditions?',
        children: [
          'Arthritis, hypertension or high cholesterol',
          'Any condition(s) for which your are on medication that lasted more than 14 days, require medical treatment or follow up, or have recurring symptoms and have yet to seek medical advice',
        ],
        value: this.getValue(this.q2),
        id: 2
      },
      {
        text: 'Do you need the assistance of another person or mechanical aids to perform activities of daily living such as washing, dressing, feeding, toileting, walking or moving around and transferring? ',
        value: this.getValue(this.q3),
        id: 3
      },
      {
        text: 'Have you, in the last 12 months, experienced any reduced or restricted ability in doing any of the following day-to-day activities due to your health condition(s)?',
        children: [
          'Housework, preparing meals, shopping for groceries or personal needs',
          'Using public transport or participating in social activities',
        ],
        value: this.getValue(this.q4),
        id: 4
      },
      {
        text: 'Does your total monthly benefit for Long Term Care Coverage exceed $3,000 (current application plus existing cover with us and other insurers)?',
        children: [
        ],
        value: this.getValue(this.q5),
        id: 5
      },
    ];

    if (this.q5 === 'Y') {
      list.push({
        text: `Have you done predictive genetic test on Huntington's disease (HTT)?`,
        children: [
        ],
        value: this.q6 === 'Y'  ? 'Yes' : 'Not tested before',
        id: 6
      })
    }


    return list;
  }

  getValue(id: any): string{
    // console.log(id);
    return id === 'Y'  ? 'Yes' : 'No';
    // return 'No'
  }
}